<template>
  <v-card flat rounded="lg">
    <v-card-title>Documentação</v-card-title>
    <v-card-text>      
      <envio-documentacao />
    </v-card-text>
  </v-card>
</template>

<script>
import EnvioDocumentacao from "@/components/inscricao/EnvioDocumentacao.vue";
import { mapState } from 'vuex';

export default {
  computed: mapState(["candidato"]),
  components: { EnvioDocumentacao },
};
</script>

<style>
</style>